(() => {
  const hub = window.Kl24PokemonHub;
  if (!hub) return;

  document.querySelectorAll('[data-hub-tile]').forEach((el) => {
    el.addEventListener('click', () => {
      hub.trackHubEvent('hub_tile_click', {
        tile: el.getAttribute('data-hub-tile') || 'unknown',
      });
    });
  });

  document.querySelectorAll('[data-hub-hero-cta]').forEach((el) => {
    el.addEventListener('click', () => {
      hub.trackHubEvent('hub_hero_cta_click', {
        variant: el.getAttribute('data-hub-hero-cta') || 'primary',
        href: el.getAttribute('href') || '',
      });
    });
  });

  document.querySelectorAll('[data-hub-closing-cta]').forEach((el) => {
    el.addEventListener('click', () => {
      hub.trackHubEvent('hub_closing_cta_click', {
        variant: el.getAttribute('data-hub-closing-cta') || 'primary',
        href: el.getAttribute('href') || '',
      });
    });
  });

  document.addEventListener('click', (event) => {
    const recentCard = event.target.closest('[data-hub-recent-card]');
    if (recentCard) {
      hub.trackHubEvent('hub_recent_single_click', {
        variant_id: recentCard.getAttribute('data-variant-id') || '',
        href: recentCard.getAttribute('href') || '',
      });
      return;
    }
    const gapSet = event.target.closest('[data-hub-gap-set]');
    if (gapSet) {
      hub.trackHubEvent('hub_gap_set_click', {
        set_handle: gapSet.getAttribute('data-hub-gap-set') || '',
      });
    }
  });

  if (document.body.classList.contains('template-tcg-singles-shop') || document.querySelector('[data-tcg-singles-shop]')) {
    document.addEventListener('click', (event) => {
      const chip = event.target.closest('.tcg-singles-shop__filter-chip.is-active, .tcg-singles-shop__filter-chip');
      if (!chip || !chip.classList.contains('is-active')) return;
      const panel = chip.closest('.tcg-singles-shop__filter-panel');
      hub.trackHubEvent('singles_filter_apply', {
        filter_key: panel?.dataset?.filterKey || '',
        filter_value: chip.dataset.filterValue || '',
      });
    });
  }
})();
